var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.619167 21.65V7.65C0.627067 5.62353 1.43558 3.68231 2.86853 2.24937C4.30147 0.816425 6.24269 0.00790712 8.26916 6.54493e-06H22.2092C23.2202 -0.00131339 24.2216 0.197027 25.1559 0.583644C26.0901 0.970261 26.9388 1.53755 27.6533 2.25295C28.3678 2.96836 28.934 3.8178 29.3194 4.75254C29.7048 5.68729 29.9018 6.68893 29.8992 7.70001V21.7C29.8913 23.7265 29.0827 25.6677 27.6498 27.1006C26.2169 28.5336 24.2756 29.3421 22.2492 29.35H17.5192L15.0692 28.75L12.9492 29.35H8.26916C6.23404 29.3421 4.28527 28.5267 2.8509 27.0829C1.41653 25.6392 0.613852 23.6851 0.619167 21.65Z",
    fill: "url(#paint0_linear_701_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9002 19.3802L21.5502 15.1502H17.5202V12.4102C17.4939 12.0954 17.5382 11.7787 17.65 11.4832C17.7617 11.1877 17.9382 10.921 18.1663 10.7024C18.3944 10.4839 18.6685 10.3191 18.9685 10.2201C19.2685 10.1211 19.5868 10.0904 19.9002 10.1302H21.7402V6.53024C20.6589 6.35256 19.5659 6.25562 18.4702 6.24023C15.1302 6.24023 12.9402 8.24024 12.9402 11.9302V15.1502H9.24023V19.3802H12.9502V29.3002H17.5202V19.3802H20.9002Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_701_2",
    x1: 27.6092,
    y1: 2.30001,
    x2: 2.85916,
    y2: 27.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4676ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#436DE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3C55CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#302EA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1E99"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.96cf5a71148530cfd02b6d4d10a63b85.svg";
export { ForwardRef as ReactComponent };